import styled from "styled-components";

export const LightStrongDefaultBox = styled.div<{boxShadowBlurSize: number;}>`
    position: absolute;
    width: 146%;
    height: 146%;
    border-radius: 50%;

    transition: background-color, box-shadow 0.15s ease;
    background-color: hsla(0, 0%, 100%, 15%);
    filter: blur(4px);
    box-shadow: hsla(54, 100%, 85%, 0.059) -1px -1px ${props => props.boxShadowBlurSize}px ${props => props.boxShadowBlurSize}px;
`;
